import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {
  InspectionCase,
  InspectionVentilationSystemAndFireProtection
} from '@authority-labs/api-interfaces';

@Component({
  selector:
    'authority-labs-ventilation-system-and-fire-protection-in-commercial-cooking-systems',
  templateUrl:
    './ventilation-system-and-fire-protection-in-commercial-cooking-systems.component.html',
  styleUrls: [
    './ventilation-system-and-fire-protection-in-commercial-cooking-systems.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VentilationSystemAndFireProtectionInCommercialCookingSystemsComponent
  implements OnInit
{
  @Input() data: InspectionVentilationSystemAndFireProtection;
  @Input() readonly: boolean;
  @Input() printPreview: boolean;
  @Output() dataChange: EventEmitter<void> = new EventEmitter();

  caseTitlesMap: Map<string, InspectionCase[]> = new Map();

  constructor() {}

  ngOnInit(): void {
    this.setCaseTitlesMap();
  }

  onDataChange(): void {
    this.setCaseTitlesMap();
    this.dataChange.emit();
  }

  isParentShown(parentSection: string, section: string): boolean {
    const parents = this.caseTitlesMap
      .get(parentSection)
      .filter((sc) => (section + '.').startsWith(sc.section + '.'));
    return parents.every((p) => p.isApplicable || p.section === section);
  }

  getParent(parentSection: string, section: string): string {
    const parents = this.caseTitlesMap
      .get(parentSection)
      .filter(
        (sc) =>
          (section + '.').startsWith(sc.section + '.') && section !== sc.section
      );
    return parents[parents.length - 1]?.section;
  }

  margin(parentSection: string, section: string): string {
    const parent = this.getParent(parentSection, section) || '';

    const margin =
      parent.split('.').length - 1 >= 1
        ? `${(parent.split('.').length - 1) * 35}px`
        : '0';

    return margin;
  }

  private setCaseTitlesMap() {
    this.data.cases.forEach((c) => {
      this.caseTitlesMap.set(
        c.section,
        c.subCases.filter((sc) => sc.isTitle)
      );
    });
  }
}
